import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { twitterPageURL } from '../../util/urlHelpers';
import config from '../../config';
import {
  IconSocialMediaFacebook,
  IconSocialMediaInstagram,
  IconSocialMediaTwitter,
  Logo,
  ExternalLink,
  NamedLink,
} from '../../components';
import IconSocialMediaLinkedin from '../IconSocialMediaLinkedin/IconSocialMediaLinkedin';
import call from './call.png';
import mail from './mail.png';
import Grid from '@material-ui/core/Grid';

import css from './Footer.module.css';

const renderSocialMediaLinks = intl => {
  const { siteFacebookPage, siteInstagramPage, siteTwitterHandle } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const goToFb = intl.formatMessage({ id: 'Footer.goToFacebook' });
  const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });
  const goToTwitter = intl.formatMessage({ id: 'Footer.goToTwitter' });

  const fbLink = siteFacebookPage ? (
    <ExternalLink key="linkToFacebook" href={siteFacebookPage} className={css.icon} title={goToFb}>
      <IconSocialMediaFacebook />
    </ExternalLink>
  ) : null;

  const twitterLink = siteTwitterPage ? (
    <ExternalLink
      key="linkToTwitter"
      href={siteTwitterPage}
      className={css.icon}
      title={goToTwitter}
    >
      <IconSocialMediaTwitter />
    </ExternalLink>
  ) : null;

  const instragramLink = siteInstagramPage ? (
    <ExternalLink
      key="linkToInstagram"
      href={siteInstagramPage}
      className={css.icon}
      title={goToInsta}
    >
      <IconSocialMediaInstagram />
    </ExternalLink>
  ) : null;
  return [fbLink, twitterLink, instragramLink].filter(v => v != null);
};

const Footer = props => {
  const { rootClassName, className, intl } = props;
  const socialMediaLinks = renderSocialMediaLinks(intl);
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.topBorderWrapper}>
        <div className={css.content}>
          {/* <div className={css.someLiksMobile}>{socialMediaLinks}</div> */}
          <div className={css.links}>
            <div className={css.organization} id="organization">
              <NamedLink name="LandingPage" className={css.logoLink}>
                <Logo format="desktop" className={css.logo} />
              </NamedLink>
              <div className={css.organizationInfo}>
                <p className={css.organizationDescription}>
                  <FormattedMessage id="Footer.organizationDescription" />
                </p>
              </div>
            </div>
            <div className={css.infoLinks}>
              <ul className={css.list}>
                <li className={css.listItemDisabled}>
                  <NamedLink name="NewListingPage" className={css.linkTop}>
                    Découvrir ollo
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="AboutPage" className={css.link}>
                    Comment ça marche ?
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="HelpPage" className={css.link}>
                    Centre d’aide
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <Grid container xs={4}>
                    <Grid item xs={4}>
                      <a href="https://www.facebook.com/ollo.fr/">
                        <IconSocialMediaFacebook />
                      </a>
                    </Grid>
                    <Grid item xs={4}>
                      <a href="https://www.instagram.com/ollo_fr/">
                        <IconSocialMediaInstagram />
                      </a>
                    </Grid>
                    <Grid item xs={4}>
                      <a href="https://fr.linkedin.com/company/ollogps">
                        <IconSocialMediaLinkedin />
                      </a>
                    </Grid>
                  </Grid>
                </li>
                {/* <li className={css.listItem}>
                  <NamedLink name="AboutPage" to={{ hash: '#contact' }} className={css.link}>
                    <FormattedMessage id="Footer.toContactPage" />
                  </NamedLink>
                </li> */}
              </ul>
            </div>
            <div className={css.infoLinks}>
              <ul className={css.list}>
                <li className={css.listItemDisabled}>
                  <NamedLink name="NewListingPage" className={css.linkTop}>
                    Information légales
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="CGUPage" className={css.link}>
                    CGU
                  </NamedLink>
                </li>
                <li className={css.listItem}>
                  <NamedLink name="PrivacyPolicyPage" className={css.link}>
                    Conditions d'utilisation
                  </NamedLink>
                </li>
              </ul>
            </div>
            <div className={css.infoLinks}>
              <ul className={css.list}>
                <li className={css.listItemDisabled}>
                  <span className={css.linkTop}>Contactez-nous</span>
                </li>
                <li className={css.listItem}>
                  <span className={css.link}>
                    <img className={css.smallIcon} src={mail} /> contact@ollo.fr
                  </span>
                </li>
                <li className={css.listItem}>
                  <span className={css.link}>
                    <img className={css.smallIcon} src={call} />
                    +33 7 56 82 91 46
                  </span>
                </li>
                <li className={css.listItem}>
                  <span className={css.link}>7j/7 - 24h/24</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Footer.defaultProps = {
  rootClassName: null,
  className: null,
};

Footer.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);
